import { db } from '../client/index';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc } from 'firebase/firestore/lite';

const rolesCollection = collection(db, 'roles');

export const getRoles = async () => {
  try {
    const rolesSnapshot = (await getDocs(rolesCollection)).docs;
    const rolesItems = rolesSnapshot.map(role => role.data());
    return rolesItems;
  } catch (err) {
    return err;
  }
}

export const getRole = async (id) => {
  try {
    const roleSnapshot = doc(db, 'roles', id);
    const roleItem = await getDoc(roleSnapshot);
    return roleItem.exists() ? {
      id: roleItem.ref.id,
      ...roleItem.data()
    } : null;
  } catch (err) {
    return err;
  }
}

export const createRole = async (role) => {
  try {
    const { id } = await addDoc(rolesCollection, role);
    const roleAdded = { id, ...role };
    return roleAdded;
  } catch (err) {
    return err;
  }
}

export const updateRole = async (id, role) => {
  try {
    const roleRef = doc(db, 'roles', id);
    await updateDoc(roleRef, role);
    return { id, ...role };
  } catch (err) {
    return err;
  }
}

export const deleteRole = async (id) => {
  try {
    const roleRef = doc(db, 'roles', id);
    await deleteDoc(roleRef);
    return id;
  } catch (err) {
    return err;
  }
}
